import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CBTCOFNC_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cbtcofnc/logo.png",
        alt: "CBT Counseling of NC Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 25,
  state: "NC",
  departmentIds: [98, 107, 115, 135, 137, 142, 148, 150, 162, 263, 268, 271],
};
